import { render, staticRenderFns } from "./Cdb.vue?vue&type=template&id=d22e2526&"
import script from "./Cdb.vue?vue&type=script&lang=js&"
export * from "./Cdb.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports